<style lang="less">
    @import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list">
        <div class="table-list" style="margin-top:25px;height: auto;min-height: 726px;">
            <div class="table-list-title">
                <span style="margin-left:25px">附加服务列表</span>
                <div class="choose-group">
                    <span class="choose-group-span">时间</span>
                    <Date-picker v-model="dateValue"
                                 format="yyyy-MM-dd"
                                 type="daterange"
                                 placement="bottom-end"
                                 placeholder="选择日期"
                                 @on-change="timeChange"

                                 style="width: 200px"></Date-picker>
                    <span class="choose-group-span">请选择服务名称</span>
                    <i-select v-model="serviceValue" placeholder="全部" style="width:126px" @on-change="selectType">
                        <i-option v-for="(item,index) in serviceList" :key="index" :value="item.subBizType">{{ item.name}}</i-option>
                    </i-select>
                    <i-input v-model="serviceProduct"
                             ref="serviceProductInput"
                             :search="true"
                             @on-search="searchReset"
                             placeholder="请输入作品名称"
                             style="width: 205px"
                             class="select-input-style"></i-input>
                    <button @click="searchReset" class="btn-84" style="margin-right:30px">查询</button>
                </div>
            </div>

            <Row class="table-style-size">
                <i-col span="6">服务名称</i-col>
                <i-col span="6">作品名称</i-col>
                <i-col span="6">提交时间</i-col>
                <i-col span="5">状态</i-col>
            </Row>

            <errorTips :state="0" v-if="loadFlag && orderList.length == 0"></errorTips>

            <div v-else>
                <!--       数据列表         -->
                <Row class="table-style-size table-style-body" v-for="(item,index) in orderList" :key="index">
                    <i-col span="6">{{item.subBizTypeCn ? item.subBizTypeCn  : ''}}
                    </i-col>
                    <i-col span="6">
                        <Tooltip :content="item.workFullName" placement="top">
                            <span class="text-overflow-2" style="padding:0 5px">{{ item.workFullName }}</span>
                        </Tooltip>
                    </i-col>
                    <i-col span="6">{{item.createDate?item.createDate:''}}</i-col>
                    <i-col span="5">{{item.statusCn?item.statusCn:''}}</i-col>
                </Row>

                <!--       分页     -->
                <div class="commont-page" style="position: absolute;bottom: 10px;left: 50%;transform: translate(-50%, -50%);">
                    <Page @on-change="changepage"
                          :current="pageNumber"
                          :total="total"
                          size="small"
                          show-total
                          show-elevator
                          :page-size="pageSize"
                          class="page-size-style"></Page>
                    <span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    import {getOtherService} from '@/api/staticPage'
    import Cookies from "js-cookie";
    import errorTips from '@/views/main-components/error-tips';

    export default {
        metaInfo: {
            title: '附加服务列表|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '附加服务列表,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'myDci-order',
        components: {
            errorTips
        },
        data() {
            return {
                userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                total: 0,
                pageNumber: 1,
                pages: 1,
                pageSize: 8,
                serviceProduct: '', //服务产品
                dateValue: [], //日期数组
                orderList: [],
                serviceList:[
                    {name:'全部',subBizType:'all'},
                    {name:'纸质版权登记',subBizType:'0211'},
                    {name:'证书查询',subBizType:'0212'},
                    {name:'证书撤销',subBizType:'0213'},
                    {name:'作品变更',subBizType:'0214'},
                ], //服务类别
                serviceValue:'all', //下拉框当前选中
                subBizType:'', //请求数据的类型
                loadFlag:false //加载flag
            }
        },
        mounted() {
            this._getOtherService()
        },
        methods: {
            /*********获取数据内容********/
            _getOtherService() {
                this.$refs['serviceProductInput'].blur();
                let data = {
                    registerId: this.userInfo.id,
                    startDate: (this.dateValue[0] ? this.dateValue[0] : ''),
                    endDate: (this.dateValue[1] ? this.dateValue[1] : ''),
                    workFullName: this.serviceProduct,
                    pageSize: this.pageSize,
                    pageNumber: this.pageNumber,
                    subBizType:this.subBizType,
                    sort: 'create_date',
                    order: 'desc'
                };
                getOtherService(data).then(res => {
                    if ( res && res.code == 200) {
                        let result = res.result;
                        this.total = result.total - 0;
                        this.pages = result.pages;
                        this.orderList = result.records;
                        this.loadFlag = true;
                    } else {
                        toast(res.message);
                    }
                }, (err) => {
                    toast('网络断开连接，请重试')
                })
            },

            /*********跳转详情页********/
            goDetailsid(id) {
                this.$router.push({
                    path: '/legalOrderDetails',
                    query: {id: id}
                })
                // this.getRequest('/lawOrder/get/'+id).then(res=>{
                //     console.log('获取的详情的接口',res)
                // })
            },

            /*********时间改变事件********/
            timeChange(value) {
                this.dateValue = value;
                this.searchReset()
            },

            /*********页数改变事件********/
            changepage(index) {
                this.pageNumber = index;
                this._getOtherService()
            },

            /*********搜索重置事件********/
            searchReset() {
                this.pageNumber = 1;
                this._getOtherService();
            },
            selectType(val) {
                console.log('这是获取的类型', val)
                this.subBizType = val == 'all' ? '' : val;
                this.pageNumber = 1;
                this._getOtherService();
            },
        }
    }
</script>
